import { apiFetch } from "@/lib/api";

export type ClampQcInspectionRecordRequest = {
  buildOrderId: number;
  serialKey: number;
  serialText: string;
  submittedAtIso: string;
  sku: string;
  /** True when this serial is in the stratified inductance sample for the work order. */
  inductanceMeasurementRequired: boolean;
  physicalFailReasonLabels: string[];
  sgsInductance: number | null;
  sgsLineHarvestPerformed: boolean;
  sgsLineHarvestPass: boolean | null;
  sgsLineHarvestDrag: number | null;
  sgsLineHarvestTester: boolean;
  sgsUnloadedLine: number | null;
  sgsLoadedLineBeforeTester: number | null;
  sgsLoadedLineWithTester: number | null;
  inventoryBoxHex?: string | null;
};

export type ClampQcInspectionRecordResponse = {
  ok: boolean;
  clampId: string;
  serialKey: number;
  serial: string;
  boxFilledCount?: number | null;
  inventoryBoxHex?: string | null;
};

export async function postClampQcInspectionRecord(
  body: ClampQcInspectionRecordRequest,
): Promise<ClampQcInspectionRecordResponse> {
  return apiFetch<ClampQcInspectionRecordResponse>("/api/clamp-qc/inspection-record", {
    method: "POST",
    body,
  });
}
